var _circle, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPairedTokens(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12.5,
    r: 12,
    fill: "#434647",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 15.4985C11.1287 15.4985 11.7504 15.3667 12.3251 15.1117C12.8997 14.8567 13.4146 14.4842 13.8364 14.018C14.2583 13.5518 14.5778 13.0025 14.7743 12.4053C14.9708 11.8081 15.0401 11.1764 14.9775 10.5508C15.5407 10.7923 16.0362 11.1682 16.4205 11.6456C16.8049 12.1229 17.0664 12.6871 17.1823 13.2889C17.2981 13.8907 17.2647 14.5117 17.085 15.0976C16.9053 15.6835 16.5848 16.2165 16.1515 16.6499C15.7182 17.0832 15.1853 17.4038 14.5994 17.5836C14.0135 17.7634 13.3925 17.7969 12.7907 17.6811C12.1889 17.5654 11.6246 17.3039 11.1472 16.9197C10.6698 16.5354 10.2939 16.04 10.0522 15.4768C10.2007 15.4913 10.35 15.4985 10.5 15.4985Z",
    fill: "#434647",
    fillOpacity: 0.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 14.75C12.5711 14.75 14.25 13.0711 14.25 11C14.25 8.92893 12.5711 7.25 10.5 7.25C8.42893 7.25 6.75 8.92893 6.75 11C6.75 13.0711 8.42893 14.75 10.5 14.75Z",
    fill: "#434647",
    fillOpacity: 0.9
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPairedTokens);
export default __webpack_public_path__ + "static/media/paired-tokens.3cfbc4dfb1e8b585ec66caef792fa379.svg";
export { ForwardRef as ReactComponent };